import { OrdersPage } from '@apps-common/apps/portal/pages/orders/Index'

export const Orders = () => <OrdersPage />
